/* eslint-disable max-len */
import { OV_EMS_CDN, OV_CDN } from '../../../config/theme';
export var CDN_ROOT = "".concat(OV_EMS_CDN, "media/dresses-campaign/");
export var CDN = "".concat(OV_CDN, "video/dresses-campaign/");
export var DRESSES = [{
  component: 'Dress1',
  copy: 'Our all-star dress, the one that started it all. Pairs best with adventure. Designed to make you feel strong.',
  name: 'The Exercise Dress',
  url: '/products/w-the-exercise-dress',
  images: [{
    alt: 'Azure',
    height: 526,
    href: '/products/w-the-exercise-dress?variant=39793991647310',
    src: "".concat(CDN_ROOT, "TED-1.jpg"),
    width: 407
  }, {
    alt: 'Dayflower',
    height: 326,
    href: '/products/w-the-exercise-dress?variant=39740452503630',
    src: "".concat(CDN_ROOT, "TED-2.jpg"),
    userHandle: '@jamie_zella',
    width: 326
  }, {
    alt: 'Mango',
    height: 283,
    href: '/products/w-the-exercise-dress?variant=39844160077902',
    src: "".concat(CDN_ROOT, "TED-3.jpg"),
    width: 218
  }, {
    alt: 'Wavy Checker',
    height: 294,
    href: '/products/w-the-exercise-dress?variant=39863519412302',
    src: "".concat(CDN_ROOT, "TED-4.jpg"),
    width: 513
  }, {
    alt: 'TED PDP',
    height: 262,
    href: '/products/w-the-exercise-dress',
    src: "".concat(CDN_ROOT, "TED-5.jpg"),
    userHandle: '@phaithmontoya',
    width: 262
  }, {
    alt: 'Navy',
    height: 420,
    href: '/products/w-the-exercise-dress?variant=39439379464270',
    src: "".concat(CDN_ROOT, "TED-6.jpg"),
    width: 325
  }, {
    alt: 'Primrose',
    height: 314,
    href: '/products/w-the-exercise-dress?variant=39743908511822',
    src: "".concat(CDN_ROOT, "TED-7.jpg"),
    width: 221
  }],
  quotes: [{
    name: 'Emalee',
    text: 'If I could tell everyone to get this dress, I would. It is the perfect material, weight, fit and style that makes you feel feminine, sporty, chic and most importantly—confident!'
  }, {
    name: 'Claudia',
    text: 'What was my life before this dress? I have never loved something so much.”'
  }],
  video: {
    src: 'TED2.mp4',
    srcMobile: 'TEDMobile2.mp4'
  }
}, {
  component: 'Dress2',
  copy: 'Go on, show some shoulder. A dress for impromptu Recreation and now newly lined. As in, this dress has serious game.',
  name: 'One Shoulder Dress',
  url: '/products/w-one-shoulder-dress-with-liner',
  images: [{
    alt: 'White',
    height: 999,
    href: '/products/w-one-shoulder-dress-with-liner?variant=39833034555470',
    src: "".concat(CDN_ROOT, "OneShoulder-1.jpg"),
    width: 750
  }, {
    alt: 'Dark Sky',
    height: 1068,
    href: '/products/w-one-shoulder-dress-with-liner?variant=39831457300558',
    src: "".concat(CDN_ROOT, "OneShoulder-2.jpg"),
    width: 1842
  }, {
    alt: 'White',
    height: 1263,
    href: '/products/w-one-shoulder-dress-with-liner?variant=39833034555470',
    src: "".concat(CDN_ROOT, "OneShoulder-3.jpg"),
    width: 951
  }, {
    alt: 'Black',
    height: 819,
    href: '/products/w-one-shoulder-dress-with-liner?variant=39833034457166',
    src: "".concat(CDN_ROOT, "OneShoulder-4.jpg"),
    userHandle: '@so.much.grace',
    width: 819
  }, {
    alt: 'Black',
    height: 651,
    href: '/products/w-one-shoulder-dress-with-liner?variant=39833034457166',
    src: "".concat(CDN_ROOT, "OneShoulder-5.jpg"),
    width: 1050
  }, {
    alt: 'White',
    height: 1695,
    href: '/products/w-one-shoulder-dress-with-liner?variant=39833034555470',
    src: "".concat(CDN_ROOT, "OneShoulder-6.jpg"),
    width: 1311
  }],
  quotes: [{
    name: 'Gabrielle',
    text: 'I recently wore it on a trip to Big Sur, and can attest it&rsquo;s perfect for a walk around town but also transferable go hiking attire!'
  }, {
    name: 'Audrey',
    text: 'I want to live in this dress, I&rsquo;m not kidding.'
  }],
  video: {
    src: 'OneShoulder2.mp4',
    srcMobile: 'OneShoulderMobile2.mp4'
  }
}, {
  component: 'Dress1',
  copy: "Easy as pie, and just about the most delightful dress we've made. A slight flare, with a high neck, for that throw on and go day.",
  name: 'Bloom Dress',
  url: '/products/w-bloom-dress',
  images: [{
    alt: 'White',
    height: 526,
    href: '/products/w-bloom-dress?variant=39914400710734',
    src: "".concat(CDN_ROOT, "Bloom-1.jpg"),
    width: 407
  }, {
    alt: 'Navy',
    height: 326,
    href: '/products/w-bloom-dress?variant=39914400710734',
    src: "".concat(CDN_ROOT, "Bloom-2.jpg"),
    width: 326
  }, {
    alt: 'White',
    height: 283,
    href: '/products/w-bloom-dress?variant=39914400710734',
    src: "".concat(CDN_ROOT, "Bloom-3.jpg"),
    width: 218
  }, {
    alt: 'White',
    height: 294,
    href: '/products/w-bloom-dress?variant=39914400710734',
    src: "".concat(CDN_ROOT, "Bloom-4.jpg"),
    width: 513
  }, {
    alt: 'Navy',
    height: 262,
    href: '/products/w-bloom-dress?variant=39914400710734',
    src: "".concat(CDN_ROOT, "Bloom-5.jpg"),
    width: 262
  }, {
    alt: 'White',
    height: 420,
    href: '/products/w-bloom-dress?variant=39914400710734',
    src: "".concat(CDN_ROOT, "Bloom-6.jpg"),
    width: 325
  }, {
    alt: 'Navy',
    height: 314,
    href: '/products/w-bloom-dress?variant=39914400710734',
    src: "".concat(CDN_ROOT, "Bloom-7.jpg"),
    width: 221
  }],
  quotes: [{
    name: 'Sophie',
    text: 'The high neck gives great sun protection while keeping the dress stylish and flattering. The material is sculpting but breathable and the perfect thickness. Love it!'
  }, {
    name: 'Charlotte',
    text: '“A perfect fit! Very comfortable. Perfect length. Very flattering.”'
  }],
  video: {
    src: 'Bloom.mp4',
    srcMobile: 'BloomMobile.mp4'
  }
}, {
  component: 'Dress2',
  copy: 'Our most supportive dress yet. Pairs best with high sweat activity, whether team sport or solo play. Go ahead, zip it up and get moving.',
  name: 'Powerhouse Dress',
  url: '/products/w-powerhouse-dress',
  images: [{
    alt: 'White',
    height: 999,
    href: '/products/w-powerhouse-dress?variant=39914400415822',
    src: "".concat(CDN_ROOT, "Power-1.jpg"),
    width: 750
  }, {
    alt: 'Dark Sky',
    height: 1068,
    href: '/products/w-powerhouse-dress?variant=39914400776270',
    src: "".concat(CDN_ROOT, "Power-2.jpg"),
    width: 1842
  }, {
    alt: 'White',
    height: 1263,
    href: '/products/w-powerhouse-dress?variant=39914400415822',
    src: "".concat(CDN_ROOT, "Power-3.jpg"),
    width: 951
  }, {
    alt: 'Black',
    height: 819,
    href: '/products/w-powerhouse-dress?variant=39914400776270',
    src: "".concat(CDN_ROOT, "Power-4.jpg"),
    width: 819
  }, {
    alt: 'Black',
    height: 651,
    href: '/products/w-powerhouse-dress?variant=39914400415822',
    src: "".concat(CDN_ROOT, "Power-5.jpg"),
    width: 1050
  }, {
    alt: 'White',
    height: 1695,
    href: '/products/w-powerhouse-dress?variant=39914400776270',
    src: "".concat(CDN_ROOT, "Power-6.jpg"),
    width: 1311
  }],
  quotes: [{
    name: 'Sophie',
    text: 'The fit is extra secure with well-placed clasps in addition to the zipper to keep everything in place. The material is smooth and the cut is super flattering.'
  }, {
    name: 'Charlotte',
    text: 'Supportive and so comfortable.'
  }],
  video: {
    src: 'Powerhouse.mp4',
    srcMobile: 'PowerhouseMobile.mp4'
  }
}, {
  component: 'Dress3',
  copy: 'In this dress, baby&rsquo;s got back. Pairs best with weekend play, designed to keep you sweet from the moment you step in.',
  name: 'Cross Back Dress',
  url: '/products/w-cross-back-dress',
  images: [{
    alt: 'Arctic',
    height: 651,
    href: '/products/w-cross-back-dress?variant=39874707882062',
    src: "".concat(CDN_ROOT, "Cross-1.jpg"),
    width: 1050
  }, {
    alt: 'Ladybug',
    height: 1950,
    href: '/products/w-cross-back-dress?variant=39873560969294',
    src: "".concat(CDN_ROOT, "Cross-2.jpg"),
    width: 1311
  }, {
    alt: 'Ladybug',
    height: 819,
    href: '/products/w-cross-back-dress?variant=39873560969294',
    src: "".concat(CDN_ROOT, "Cross-3.jpg"),
    userHandle: '@hala_thehustler',
    width: 819
  }, {
    alt: 'Black',
    height: 819,
    href: '/products/w-cross-back-dress?variant=39873560477774',
    src: "".concat(CDN_ROOT, "Cross-4.jpg"),
    width: 819
  }, {
    alt: 'Arctic',
    height: 1110,
    href: '/products/w-cross-back-dress?variant=39874707882062',
    src: "".concat(CDN_ROOT, "Cross-5.jpg"),
    width: 750
  }, {
    alt: 'White',
    height: 1068,
    href: '/products/w-cross-back-dress?variant=39873560707150',
    src: "".concat(CDN_ROOT, "Cross-6.jpg"),
    width: 1944
  }],
  quotes: [{
    name: 'Emma',
    text: 'For my fellow tall/curvy/busty ladies: I was skeptical, but this dress will make you feel like a fu***ing knockout!'
  }, {
    name: 'Riley',
    text: 'Best exercise dress! Love the seams down the front, wide straps, square neck, slight A line, and shorts that stay put.'
  }],
  video: {
    src: 'CrossBack.mp4',
    srcMobile: 'CrossBackMobile.mp4'
  }
}, {
  component: 'Dress1',
  copy: 'Made for summer recreation, designed for all-out sport. Engineered with top fit and function for high-scoring days.',
  name: 'Ace Dress',
  url: '/products/w-ace-dress',
  images: [{
    alt: 'White',
    height: 526,
    href: '/products/w-ace-dress?variant=39884812025934',
    src: "".concat(CDN_ROOT, "Ace-1.jpg"),
    width: 407
  }, {
    alt: 'Navy',
    height: 326,
    href: '/products/w-ace-dress?variant=39888306208846',
    src: "".concat(CDN_ROOT, "Ace-2.jpg"),
    userHandle: '@syd.skips',
    width: 326
  }, {
    alt: 'White',
    height: 283,
    href: '/products/w-ace-dress?variant=39884812025934',
    src: "".concat(CDN_ROOT, "Ace-3.jpg"),
    width: 218
  }, {
    alt: 'White',
    height: 294,
    href: '/products/w-ace-dress?variant=39884812025934',
    src: "".concat(CDN_ROOT, "Ace-4.jpg"),
    width: 513
  }, {
    alt: 'Navy',
    height: 262,
    href: '/products/w-ace-dress?variant=39888306208846',
    src: "".concat(CDN_ROOT, "Ace-5.jpg"),
    width: 262
  }, {
    alt: 'White',
    height: 420,
    href: '/products/w-ace-dress?variant=39884812025934',
    src: "".concat(CDN_ROOT, "Ace-6.jpg"),
    width: 325
  }, {
    alt: 'Navy',
    height: 314,
    href: '/products/w-ace-dress?variant=39888306208846',
    src: "".concat(CDN_ROOT, "Ace-7.jpg"),
    width: 221
  }],
  quotes: [{
    name: 'Haley',
    text: 'The adjustable zipper is the perfect addition to add a layer of comfort and security while keeping me cool. The material is light and stretchy, my sweat rolls right off!'
  }, {
    name: 'Parisa',
    text: 'I love this dress! It&rsquo;s incredibly flattering and comfortable on. It&rsquo;s a very breathable fabric.'
  }],
  video: {
    src: 'Ace.mp4',
    srcMobile: 'AceMobile.mp4'
  }
}, {
  component: 'Dress3',
  copy: 'Our bestselling tank, now in a dress. Made for faster, freer, fuller movement. Built to handle sweat.',
  name: 'Move Free Dress',
  url: '/products/w-move-free-dress',
  images: [{
    alt: 'Passionfruit',
    height: 651,
    href: '/products/w-move-free-dress?variant=39807521620046',
    src: "".concat(CDN_ROOT, "Move-1.jpg"),
    width: 1050
  }, {
    alt: 'Baltic',
    height: 1950,
    href: '/products/w-move-free-dress?variant=39807521849422',
    src: "".concat(CDN_ROOT, "Move-2.jpg"),
    width: 1311
  }, {
    alt: 'Jadeite',
    height: 819,
    href: '/products/w-move-free-dress?variant=39807521194062',
    src: "".concat(CDN_ROOT, "Move-3.jpg"),
    userHandle: '@aalexabee',
    width: 819
  }, {
    alt: 'Jadeite',
    height: 819,
    href: '/products/w-move-free-dress?variant=39807521194062',
    src: "".concat(CDN_ROOT, "Move-4.jpg"),
    width: 819
  }, {
    alt: 'Passionfruit',
    height: 1110,
    href: '/products/w-move-free-dress?variant=39807521620046',
    src: "".concat(CDN_ROOT, "Move-5.jpg"),
    width: 750
  }, {
    alt: 'Jadeite',
    height: 1068,
    href: '/products/w-move-free-dress?variant=39807521194062',
    src: "".concat(CDN_ROOT, "Move-6.jpg"),
    width: 1944
  }],
  quotes: [{
    name: 'Savanna',
    text: 'It&rsquo;s like a new and improved exercise dress!'
  }, {
    name: 'Oorbee',
    text: 'My friends were skeptical of me skating in a dress but immediately changed their tune when I was the only one not overheated and exhausted.'
  }],
  video: {
    src: 'MoveFree2.mp4',
    srcMobile: 'MoveFreeMobile2.mp4'
  }
}, {
  component: 'Dress2',
  copy: 'Our cult-favorite FreeForm fabric. Now in full length. Made for the biiiiig stretches and that next-to-skin softness.',
  name: 'Circle Back Dress',
  url: '/products/w-flow-circle-back-dress',
  images: [{
    alt: 'Rose Garden',
    height: 332,
    href: '/products/w-flow-circle-back-dress?variant=39793986666574',
    src: "".concat(CDN_ROOT, "Circle-1.jpg"),
    width: 250
  }, {
    alt: 'Spring Fling',
    height: 356,
    href: '/products/w-flow-circle-back-dress?variant=39784266727502',
    src: "".concat(CDN_ROOT, "Circle-2.jpg"),
    width: 614
  }, {
    alt: 'Terracotta',
    height: 421,
    href: '/products/w-flow-circle-back-dress?variant=39787341578318',
    src: "".concat(CDN_ROOT, "Circle-3.png"),
    width: 317
  }, {
    alt: 'Spring Fling',
    height: 273,
    href: '/products/w-flow-circle-back-dress?variant=39784266727502',
    src: "".concat(CDN_ROOT, "Circle-4.jpg"),
    userHandle: '@sandraruizmorlett',
    width: 273
  }, {
    alt: 'Rose Garden',
    height: 217,
    href: '/products/w-flow-circle-back-dress?variant=39793986666574',
    src: "".concat(CDN_ROOT, "Circle-5.jpg"),
    width: 350
  }, {
    alt: 'Terracotta',
    height: 565,
    href: '/products/w-flow-circle-back-dress?variant=39787341578318',
    src: "".concat(CDN_ROOT, "Circle-6.jpg"),
    width: 437
  }],
  quotes: [{
    name: 'Shawna',
    text: 'So far, I&rsquo;ve done yoga and walked my dog in this dress and I love how comfortable it is! It&rsquo;s so smooth and the stretch is amazing- making it easier for me to do just about anything in this dress!'
  }, {
    name: 'Sydney',
    text: 'TED x FreeForm is what dreams are made of!!!!'
  }],
  video: {
    src: 'Circle2.mp4',
    srcMobile: 'CircleMobile2.mp4'
  }
}, {
  component: 'Dress1',
  copy: 'For days when you&rsquo;d rather just get to the court. Acts like a set, stays put like a dress. This is the crossover (think Double Time Bra + Court Skort) you didn&rsquo;t know you needed.',
  name: 'Court Dress',
  url: '/products/w-court-dress',
  images: [{
    alt: 'White',
    height: 1578,
    href: '/products/w-court-dress?variant=39774487052366',
    src: "".concat(CDN_ROOT, "Court-1.jpg"),
    width: 1263
  }, {
    alt: 'Clementine',
    height: 978,
    href: '/products/w-court-dress?variant=39774486888526',
    src: "".concat(CDN_ROOT, "Court-2.jpg"),
    userHandle: '@libbymayy',
    width: 978
  }, {
    alt: 'Seafoam',
    height: 849,
    href: '/products/w-court-dress?variant=39774486429774',
    src: "".concat(CDN_ROOT, "Court-3.jpg"),
    width: 654
  }, {
    alt: 'Clementine',
    height: 882,
    href: '/products/w-court-dress?variant=39774486888526',
    src: "".concat(CDN_ROOT, "Court-4.jpg"),
    width: 1539
  }, {
    alt: 'White',
    height: 786,
    href: '/products/w-court-dress?variant=39774487052366',
    src: "".concat(CDN_ROOT, "Court-5.jpg"),
    userHandle: '@eacourts',
    width: 786
  }, {
    alt: 'Seafoam',
    height: 1260,
    href: '/products/w-court-dress?variant=39774486429774',
    src: "".concat(CDN_ROOT, "Court-6.jpg"),
    width: 975
  }, {
    alt: 'White',
    height: 942,
    href: '/products/w-court-dress?variant=39774487052366',
    src: "".concat(CDN_ROOT, "Court-7.jpg"),
    width: 663
  }],
  quotes: [{
    name: 'Maura',
    text: 'I love this dress! Not only is it comfortable but it&rsquo;s flattering and keeps everything in place. Perfect for walking, socializing, or whatever else.'
  }, {
    name: 'Kat',
    text: 'The material is buttery soft and super comfortable!'
  }],
  video: {
    src: 'Court2.mp4',
    srcMobile: 'CourtMobile2.mp4'
  }
}];
export var FLATS = [{
  url: '/products/w-one-shoulder-dress-with-liner?variant=39709132095566',
  src: '1-2.jpg',
  name: 'One Shoulder Dress'
}, {
  url: '/products/w-ace-dress?variant=39917479231566',
  src: '2-2.jpg',
  name: 'Ace Dress'
}, {
  url: '/products/w-the-exercise-dress?variant=39793991647310',
  src: '3-2.jpg',
  name: 'The Exercise Dress'
}, {
  url: '/products/w-move-free-dress',
  src: '4-2.jpg',
  name: 'Move Free Dress'
}, {
  url: '/products/w-flow-circle-back-dress?variant=39784266727502',
  src: '5-2.jpg',
  name: 'Circle Back Dress'
}, {
  url: '/products/w-court-dress?variant=39774487052366',
  src: '6-2.jpg',
  name: 'Court Dress'
}, {
  url: '/products/w-court-dress?variant=39774486888526',
  src: '7-2.jpg',
  name: 'Court Dress'
}, {
  src: '8-2.jpg',
  name: 'Cross Back Dress',
  url: '/products/w-cross-back-dress?variant=39873560969294'
}];
export var SELECTOR = '[data-dress="true"]';
export var TRIGGER_ID = 'dresses';
export var VIDEO_PROPS = {
  autoPlay: true,
  controlsList: 'nodownload',
  crossOrigin: 'anonymous',
  loop: true,
  playsInline: true,
  muted: true,
  preload: 'auto'
};
export var VIDEO_TRACK = "".concat(OV_CDN, "video/silent-video.vtt ");